import { configureStore } from '@reduxjs/toolkit'
import draftsReducer from './features/drafts/draftSlice'
import fetchStatusQueueReducer from './features/queues/fetchStatusQueuesSlice'

export const store = configureStore({
  reducer: {
    drafts: draftsReducer,
    fetchStatusQueue: fetchStatusQueueReducer,
  },
})
